// extracted by mini-css-extract-plugin
export default {"zoomModal":"I4-z","image":"J4-z","button":"K4-z","isOverlayShown":"L4-z"};